module.exports = __webpack_public_path__ + "static/img/new_thumb3.10570e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new_thumb3.jpg
// module id = DwcW
// module chunks = 0